import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BibliaComponent } from '../file/biblia/biblia.component';
import { AuthGuard } from '../services/guards/login-guard.guard';
import { IncidenciasDashboardComponent } from './incidencias-dashboard/incidencias-dashboard.component';
import { IncidenciasComponent } from './incidencias.component';
import { OperativasComponent } from './operativas/operativas.component';
import { PreOperativasComponent } from './pre-operativas/pre-operativas.component';
import { RevisionAcComponent } from './revision-ac/revision-ac.component';

const routes: Routes = [
  {
    path: '',
    component: IncidenciasComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: IncidenciasDashboardComponent,
        children: [
          { path: 'operativas', component: OperativasComponent },
          { path: 'pre-operativas', component: PreOperativasComponent },
          { path: 'revision-ac', component: RevisionAcComponent }
        ]
      },
      { path: 'biblia', canActivate: [AuthGuard], component: BibliaComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IncidenciasRoutingModule {}
